export { default } from './breadcrumbs.tsx';
